/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Heading, Button, ButtonType, Direction, Icon, Size, TwoWayToggle, WordToggle } from '@vaisala/rockhopper-components';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { useTranslation } from 'react-i18next';
import './AppControls.scss';

export interface AppControlsProps {
  onReset: () => void;
  onToggleAdvanced: () => void;
  advancedMode: boolean;
  unitOptions: string[];
  unitIndex: number;
  onChooseUnit: (ind: number) => void;
}

const AppControls = ({ onReset, onToggleAdvanced, advancedMode, unitOptions, unitIndex, onChooseUnit }: AppControlsProps) => {
  const { t } = useTranslation();
  return (
    <div className="app-controls">
      <div className="mode-selection">
        <Heading level={4}>{t('ui.mode')}:</Heading>
        <TwoWayToggle
          className="mode-selector"
          selected={advancedMode ? Direction.Right : Direction.Left}
          onChange={onToggleAdvanced}
          rightText={t('ui.mode.advanced')}
          leftText={t('ui.mode.basic')}
        />
      </div>
      <div className="unit-selection">
        <Heading level={4}>{t('ui.units')}:</Heading>
        <WordToggle value={unitIndex.toString()} onChange={(e) => onChooseUnit(parseInt(e.target.value))}>
          {unitOptions.map((option, i) => (
            <WordToggle.Option key={i} value={i.toString()}>
              {t(option)}
            </WordToggle.Option>
          ))}
        </WordToggle>
      </div>
      <div className="options reset-button">
        <Button buttonType={ButtonType.Link} buttonSize={Size.S} startIcon={<Icon name={VaiIcon.Refresh} />} onClick={onReset}>
          {t('ui.reset')}
        </Button>
      </div>
    </div>
  );
};
export default AppControls;
